<template>
    <div class="v5-collapse" :style="{height:height}" :class="{'is-collapse':value}">
        <div ref="collapse">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'v5-collapse',
    props: {
        value: { type: Boolean, default: false }
    },
    data() {
        return {
            originHeight: null,
            height: null
        };
    },
    watch: {
        value: {
            immediate: true,
            handler(val) {
                this.height = val ? 0 : this.originHeight;
            }
        }
    },
    methods: {
        computeHeight() {
            const el = this.$refs.collapse;
            this.originHeight = el && el.offsetHeight + 'px';
        }
    },
    mounted() {
        this.computeHeight();
    }
};
</script>

<style lang="scss">
@import './style.scss';
</style>